import React from 'react';
import { Link } from 'react-router';
import { Navbar, Nav, Container, Badge } from 'react-bootstrap';
import { useAuth } from '../auth/AuthContext';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Navbar.css'; // 新增自定義樣式檔

const AppNavbar = () => {
  const { isAuthenticated, user, login, logout, loading, error } = useAuth();
  
  // 處理登入按鈕點擊
  const handleLoginClick = () => {
    login();
  };

  // 處理登出按鈕點擊
  const handleLogoutClick = () => {
    logout();
  };

  return (
    <>
      {/* 桌面版導航欄 - 只在大於 md 的屏幕顯示 */}
      <Navbar bg="light" expand="lg" fixed="top" className="d-none d-md-flex app-navbar">
        <Container>
          <Navbar.Brand as={Link} to="/">
            首頁
            {loading && <Badge bg="secondary" className="ms-2">載入中...</Badge>}
            {error && <Badge bg="danger" className="ms-2">錯誤</Badge>}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="desktop-navbar" />
          <Navbar.Collapse id="desktop-navbar">
            <Nav className="ms-auto">
              <Nav.Item>
                <Nav.Link as={Link} to="/stats">統計數據</Nav.Link>
              </Nav.Item>
              
              {!isAuthenticated ? (
                <>
                  <Nav.Item>
                    <Nav.Link onClick={handleLoginClick}>登入</Nav.Link>
                  </Nav.Item>
                </>
              ) : (
                <>
                  <Nav.Item>
                    <Nav.Link as={Link} to="/profile">個人資料</Nav.Link>
                  </Nav.Item>
                  {user?.isAdmin && (
                    <Nav.Item>
                      <Nav.Link as={Link} to="/admin">後台</Nav.Link>
                    </Nav.Item>
                  )}
                  <Nav.Item>
                    <Nav.Link onClick={handleLogoutClick}>登出</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <span className="navbar-text">歡迎，{user?.username || '用戶'}！</span>
                  </Nav.Item>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* 行動裝置底部導航欄 - 只在小於 md 的屏幕顯示 */}
      <Nav className="fixed-bottom bg-light d-md-none mobile-bottom-nav">
        <Container fluid className="p-0">
          <div className="d-flex justify-content-around w-100">
            <Nav.Item>
              <Nav.Link as={Link} to="/" className="text-center py-1">
                <i className="bi bi-house-door fs-5 d-block mb-0"></i>
                <small className="nav-text">首頁</small>
                {loading && <small className="d-block"><Badge bg="secondary" pill>載入中</Badge></small>}
              </Nav.Link>
            </Nav.Item>
            
            <Nav.Item>
              <Nav.Link as={Link} to="/stats" className="text-center py-1">
                <i className="bi bi-bar-chart fs-5 d-block mb-0"></i>
                <small className="nav-text">統計</small>
              </Nav.Link>
            </Nav.Item>
            
            {isAuthenticated ? (
              <>
                <Nav.Item>
                  <Nav.Link as={Link} to="/profile" className="text-center py-1">
                    <i className="bi bi-person fs-5 d-block mb-0"></i>
                    <small className="nav-text">個人</small>
                  </Nav.Link>
                </Nav.Item>
                
                {user?.isAdmin && (
                  <Nav.Item>
                    <Nav.Link as={Link} to="/admin" className="text-center py-1">
                      <i className="bi bi-gear fs-5 d-block mb-0"></i>
                      <small className="nav-text">後台</small>
                    </Nav.Link>
                  </Nav.Item>
                )}
                
                <Nav.Item>
                  <Nav.Link onClick={handleLogoutClick} className="text-center py-1">
                    <i className="bi bi-box-arrow-right fs-5 d-block mb-0"></i>
                    <small className="nav-text">登出</small>
                  </Nav.Link>
                </Nav.Item>
              </>
            ) : (
              <>
                <Nav.Item>
                  <Nav.Link onClick={handleLoginClick} className="text-center py-1">
                    <i className="bi bi-box-arrow-in-right fs-5 d-block mb-0"></i>
                    <small className="nav-text">登入</small>
                  </Nav.Link>
                </Nav.Item>
              </>
            )}
          </div>
        </Container>
      </Nav>
    </>
  );
};

export default AppNavbar;